/* unplugin-vue-components disabled */import { render } from "./chb-footer.vue?vue&type=template&id=5998e43b"
import script from "./chb-footer.vue?vue&type=script&lang=js"
export * from "./chb-footer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__